import { useGraphQLQuery } from '@betterment/graphql';
import { ContentLayoutF } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { AccountsCard } from './components/accounts-card/AccountsCard';
import { ActivityCard } from './components/activity-card/ActivityCard';
import { ArticlesCard } from './components/articles-card/ArticlesCard';
import { PrimaryContentCard } from './components/content-card/PrimaryContentCard';
import { SecondaryContentCard } from './components/content-card/SecondaryContentCard';
import { EmployerMatchCard } from './components/employer-match-card/EmployerMatchCard';
import { FiveTwoNineCard } from './components/five-two-nine-card/FiveTwoNineCard';
import { FourOhOneKContributionsCard } from './components/four-oh-one-k-contributions-card/FourOhOneKContributionsCard';
import { PurposeHeaderDocument } from './components/header/graphql/purposeHeader.generated';
import { Header } from './components/header/Header';
import { IraContributionsCard } from './components/ira-contributions-card/IraContributionsCard';
import { PerformanceCard } from './components/performance-card/PerformanceCard';
import { ProjectionCard } from './components/projection-card/ProjectionCard';
import { RecurringTransactionsCard } from './components/recurring-transactions-card/RecurringTransactionsCard';

import { ApplicationLayout } from '../Shared/layout/ApplicationLayout';

export const PurposePage: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(PurposeHeaderDocument, {
    variables: { id: purposeId },
    throwOnError: false,
  });

  return (
    <ErrorBoundary fallbackType="full" feature="purpose_page" owner="user_engagement">
      <ApplicationLayout pageTitle={data?.purpose.name ?? 'Purpose'}>
        <ApplicationLayout.Header>
          <Header />
        </ApplicationLayout.Header>
        <ApplicationLayout.Content>
          <ContentLayoutF>
            <ContentLayoutF.SlotContainer>
              <ContentLayoutF.Slot1
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <PrimaryContentCard />
                <PerformanceCard />
                <AccountsCard />
                <RecurringTransactionsCard />
                <FourOhOneKContributionsCard />
                <IraContributionsCard />
                <ActivityCard />
                <ArticlesCard />
              </ContentLayoutF.Slot1>
              <ContentLayoutF.Slot2
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <ProjectionCard />
                <EmployerMatchCard />
                <FiveTwoNineCard />
                <SecondaryContentCard />
              </ContentLayoutF.Slot2>
            </ContentLayoutF.SlotContainer>
          </ContentLayoutF>
        </ApplicationLayout.Content>
      </ApplicationLayout>
    </ErrorBoundary>
  );
};
